export default __webpack_public_path__ + "static/media/page1.ae6a2311.png";